import { TemplatePage } from './types';

const newsPage: TemplatePage = {
  header: {
    color: '#F3F3F5',
    icon: 'images/video-templates/news.jpg',
    title: 'News Video Templates Collection',
    title_meta: '20+ Customizable Free News Video Templates',
    description_meta:
      'Broadcast the latest news and trends in your industry with Wave.video’s 20+ customizable news video templates.',
    description:
      'Broadcast the latest news and trends in your industry with Wave.video’s 20+ customizable news video ' +
      'templates. Easily create breaking news videos that will make your message stand out.'
  },
  footer: {
    category: 'news',
    description:
      'Wave.video’s collection of customizable news video templates eases the process of creating eye-catching ' +
      'videos for your blog, email newsletter, website, or social media. All the templates are free and easy to ' +
      'edit to suit your messaging.'
  },
  content: [
    {
      type: 'templates',
      title: 'News Video ',
      search: { name: 'news', tags: 'news' }
    },
    {
      type: 'stocks',
      title: 'news',
      search: { name: 'news' }
    },
    { type: 'calendar' }
  ]
};

export default newsPage;
